import { render, staticRenderFns } from "./SquareForm.vue?vue&type=template&id=14517efc&scoped=true&"
import script from "./SquareForm.vue?vue&type=script&lang=js&"
export * from "./SquareForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14517efc",
  null
  
)

export default component.exports